import { render, staticRenderFns } from "./orderFundList.vue?vue&type=template&id=1efa6c98"
import script from "./orderFundList.vue?vue&type=script&lang=js"
export * from "./orderFundList.vue?vue&type=script&lang=js"
import style0 from "./orderFundList.vue?vue&type=style&index=0&id=1efa6c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports